module.exports = __webpack_public_path__ + "img/cut_gd1.2885b251.jpg";